module.exports = __webpack_public_path__ + "images/emoji/tulip.d202585f748252815784.png";